<template>
  <div
    class="ui-modal-body w-full grow px-4 pb-4 relative overflow-y-auto max-w-(--max-width) mx-auto">
    <slot/>
  </div>
</template>
